<template>
  <HvhModal :value="true" title="Customer Token" :isLoading="isLoading" max-width="720" @input="$emit('close')">
    <div>
      <div class="hvh-flex">
        <a :href="url" target="_blank">{{ url }}</a>
        <v-icon class="ml-3" @click="copyUrl(url)">mdi-content-copy</v-icon>
      </div>
      <div class="mt-5">
        <v-btn flat block large class="hvh-btn hvh-btn--secondary" @click="createPasswordUrl" v-if="!hasPassword && !hasPasswordToken">Create Password Url</v-btn>
        <v-btn flat block large class="hvh-btn hvh-btn--secondary" @click="resetPassword" v-if="hasPassword || hasPasswordToken">Reset Password</v-btn>
      </div>
      <div class="mt-3" v-if="passwordToken">
        <h3>Copy this url and send it to the customer.</h3>
        <div class="hvh-flex">
          <a :href="passwordTokenUrl" target="_blank">{{ passwordTokenUrl }}</a>
          <v-icon class="ml-3" @click="copyUrl(passwordTokenUrl)">mdi-content-copy</v-icon>
        </div>
      </div>
    </div>
  </HvhModal>
</template>

<script>
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';
import HvhModal from '../common/modal/HvhModal.vue'
export default {
  components: { HvhModal },
  props: ['customer'],
  data() {
    return {
      token: null,
      passwordToken: null,
      hasPassword: null,
      hasPasswordToken: null,
      isLoading: false,
    };
  },
  computed: {
    url() {
      if (this.token)
        return `${location.origin}/ITM/CustomerAccess/${this.token}`;
      return null;
    },
    passwordTokenUrl() {
      if (this.token)
        return `${location.origin}/ITM/CustomerAccess/${this.token}/CreatePassword?token=${this.passwordToken}`;
      return null;
    },
  },
  methods: {
    copyUrl(url) {
      navigator.clipboard.writeText(url)
        .then(() => this.$notify({ type: 'success', text: 'Url copied!' }));
    },
    createPasswordUrl() {
      this.isLoading = true;
      axios.post(`/ITM/Customers/${this.customer.id}/ResetPassword`)
        .then(({ data }) => {
          this.hasPasswordToken = true;
          this.passwordToken = data.passwordToken;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    resetPassword() {
      this.$confirm('Reset Password', `Are you sure you want to reset password for ${this.customer.id} ${this.customer.facilityName}?`)
        .then(this.createPasswordUrl)
        .catch(() => null);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomerToken'] = this;
    this.isLoading = true;
    axios.get(`/ITM/Customers/${this.customer.id}/Token`)
      .then(({ data }) => {
        this.token = data.token;
        this.hasPassword = data.hasPassword;
        this.hasPasswordToken = data.hasPasswordToken;
      })
      .catch(errorDebug)
      .then(() => this.isLoading = false);
  },
}
</script>